module.exports = "<div id=\"header\" [ngStyle]=\"{'background-color': config.color}\">Recent Searches</div>\n<div \tclass=\"entry\"\n\t\t\t*ngFor=\"let entry of history, let i = index\"\n\t\t\t[ngStyle]=\"{'top': (i * 50 + 24) + 'px'}\"\n\t\t\t(mousedown)=\"entryClick(entry)\">\n\t{{entry.address}}\n</div>\n<div id=\"shadow-wrapper\" [ngClass]=\"shadowClass\">\n\t<div id=\"shadow\"></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/electraLib/component/searchResults/searchResults.component.html
// module id = 433
// module chunks = 1